import { ArrowBack, Download } from "@mui/icons-material";
import { Box, Button, Paper, Tabs, Typography, styled } from "@mui/material";
import { Link } from "react-router-dom";

export const S = {
    Page: styled(Box)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        padding: theme.spacing(3, 10),
        height: "100%",
        gap: theme.spacing(13),
    })),

    Header: styled(Box)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(10),
    })),

    HeaderInner: styled(Box)(({ theme }) => ({
        display: "flex",
        gap: theme.spacing(8),
    })),

    AssetTitle: styled(Box)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
    })),

    NavigationLink: styled(Link)(({ theme }) => ({
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        textDecoration: "none",
    })),

    ArrowBack: styled(ArrowBack)(({ theme }) => ({
        color: theme.palette.primary.main,
        fontSize: theme.spacing(5),
    })),

    NavigationText: styled(Typography)(({ theme }) => ({
        fontWeight: 600,
        fontSize: theme.spacing(4),
        color: theme.palette.primary.main,
    })),

    Panel: styled(Box)(({ theme }) => ({
        display: "flex",
        justifyContent: "space-between",
        "@media print": {
            display: "none",
        },
    })),

    Tabs: styled(Tabs)(({ theme }) => ({
        marginBottom: theme.spacing(8),

        "& .MuiTabs-flexContainer": {
            display: "flex",
            gap: theme.spacing(4),
        },

        "& .MuiTabs-indicator": {
            display: "none",
        },

        "& .MuiTab-root": {
            backgroundColor: theme.palette.common.white,
            color: theme.palette.primary.main,
            border: `1px solid ${theme.palette.primary.main}`,
            borderRadius: "24px",
            padding: theme.spacing(2, 4),
            transition: "background-color 0.3s ease-in-out",
        },

        "& .MuiTab-root.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
            fontWeight: 600,
        },
    })),

    Content: styled(Paper)(({ theme }) => ({
        padding: theme.spacing(12),
        gap: theme.spacing(8),
        height: "100%",
        borderRadius: theme.spacing(2),
    })),

    Section: styled(Box)(({ theme }) => ({
        display: "flex",
        margin: theme.spacing(-20, 0, 12, 0),
    })),

    NavigationButton: styled(Button)(({ theme }) => ({
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        textDecoration: "none",
        cursor: "pointer",
    })),

    DownloadIcon: styled(Download)(({ theme }) => ({
        color: theme.palette.primary.main,
        fontSize: theme.spacing(5),
    })),
};
